<template>
    <v-layout align-top>
        <v-flex>
                <v-card flat>
        <v-card-title class="primary white--text headline">
            Equipment Health Score
        </v-card-title>
        <v-layout row wrap>
        <v-flex xs12>
            <v-card>
                <v-card-text>
                    <date-range-selector v-model="range"></date-range-selector>
                    <equipment-selector v-model="equipment" :typeFilter="equip_types"></equipment-selector>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card>
                <v-card-title class="accent white--text subheading" v-show="showSupervised">
                    Supervised Detection
                </v-card-title>
                <v-card-text v-show="showSupervised">
                    <supervised-summary :range="range" :equipment="equipment" v-on:vischange="handleSupervisedChange($event)"></supervised-summary>
                </v-card-text>

                <v-card-title class="accent white--text subheading">
                    Algorithm Detection
                </v-card-title>
                <v-card-text>
                    <anomaly-summary :range="range" :equipment="equipment"></anomaly-summary>
                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
    </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
import DateRangeSelector from '../components/DateRangeSelector'
import EquipmentSelector from '../components/EquipmentSelector'
import _ from 'lodash'
import AnomalySummary from '../components/anomaly/AnomalySummary'
import SupervisedSummary from '../components/anomaly/SupervisedSummary'
import moment from 'moment'
import {mapGetters} from 'vuex'

export default {
  name: 'AnomalyDetection',
  components: { SupervisedSummary, AnomalySummary, EquipmentSelector, DateRangeSelector },
    computed: {
        ...mapGetters([
            'anomalyEquipType',
        ]),
        equip_types() {
            if(this.anomalyEquipType){
                return this.anomalyEquipType
            } else if(this.facilityName==="CRP"){
                return "chiller"
            } else if (this.facilityName==="SHT"){
                return 'chiller,pump'
            } else {
                return 'chiller*'
            }
        },
        facilityName () {
            return this.$store.state.pointsListStore.pointsList.facility_name
        }
    },
  data () {
    return {
      loading: true,
        showSupervised:false,
        range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
      equipment: 'Chiller 1'
    }
  },
  beforeMount() {
    // popular with query
      let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
    this.equipment = _.get(this.$route.query,'equipment', null)
    let rangeStart = _.get(this.$route.query,'rangeStart', null)
    let rangeEnd =  _.get(this.$route.query,'rangeEnd', null)
    if (!!rangeStart) {
      this.range = {start: rangeStart, end: rangeEnd}
    } else if(maxDate){
          this.range={
              start:this.$store.state.pointsListStore.pointsList.facility_name=="AZBIL" ? moment(maxDate).subtract(6, "months").format('YYYY-MM-DD HH:mm:ss') : moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
              end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
          }
      }
  },
  methods: {
    updateQueryString () {
       if(this.$router.currentRoute.name==="modelsummary"){
           this.$router.replace({
               path: '/modelsummary',
               query: {
                   rangeStart: this.range.start,
                   rangeEnd: this.range.end,
                   equipment: this.equipment
               }
           }).catch(err => {})
       }
    },
      handleSupervisedChange(event){
        this.showSupervised=event;
      }
  },
  watch:{
    range () {
      this.updateQueryString()
    },
    equipment () {
      this.updateQueryString()
    }
  }
}
</script>

<style scoped>

</style>
